var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-boilerplate"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$prismic.richTextAsHTML(this.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }